export default "data:application/octet-stream;base64,PHRlbXBsYXRlPgogIDxyb3V0ZXItdmlldyAvPgo8L3RlbXBsYXRlPgo="